import Button from 'components/button';
const RemunerationSection = ({ dataCreateMission, setPage }) => (
  <div className="mx-6 border-b border-gray-200 py-2">
    <div className="flex justify-between">
      <span className="ft-b text-gray-900 font-medium">
        Rémunération de l'intérimaire
      </span>
      <Button color="DEFAULT" size="SM" onClick={() => setPage(1)}>
        Modifier
      </Button>
    </div>
    <div className="flex flex-col ft-sm">
      <span className="text-gray-900 font-medium">Taux horaire :</span>{' '}
      {dataCreateMission.salary} €/h
    </div>
  </div>
);

export default RemunerationSection;
